module.exports = __webpack_public_path__ + "static/media/letter_p.ee11cf50.m4a";